import { render, staticRenderFns } from "./parser-classes.vue?vue&type=template&id=c0640ad8&"
import script from "./parser-classes.vue?vue&type=script&lang=js&"
export * from "./parser-classes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports